import { FC, useEffect } from "react";
import { useMantineColorScheme } from "@mantine/core";
import IconSun from "/svg/sun.svg";
import IconMoon from "/svg/moon.svg";
import { useDispatch, useSelector } from "react-redux";
import styles from "./ThemeToggle.module.scss";
import { RootState } from "@app/store";
import { toggleTheme } from "../model/slice";
import { DefaultIcon } from "@shared/ui";

export const ThemeToggle: FC = () => {
  const dispatch = useDispatch();
  const { isDark } = useSelector((state: RootState) => state.theme);
  const { setColorScheme } = useMantineColorScheme();
  const root = document.documentElement;
  const stylesTheme = getComputedStyle(root);
  const mainBgColor = stylesTheme.getPropertyValue("--color-bg").trim();

  useEffect(() => {
    setColorScheme(isDark ? "dark" : "light");
    window.Telegram.WebApp.setBackgroundColor(mainBgColor);
    window.Telegram.WebApp.setHeaderColor(mainBgColor);
    window.Telegram.WebApp.setBottomBarColor(mainBgColor);
    // window.Telegram.WebApp.setBottomBarBackgroundColor(mainBgColor);
  }, [isDark, setColorScheme]);

  const handleToggle = () => {
    dispatch(toggleTheme());
  };

  return (
    <button
      className={styles.toggleButton}
      onClick={handleToggle}
      aria-label="Toggle color scheme"
    >
      {isDark ? (
        <DefaultIcon src={IconSun} className={styles.icon} />
      ) : (
        <DefaultIcon src={IconMoon} className={styles.icon} />
      )}
    </button>
  );
};
